export const API_URL = process.env.REACT_APP_API_URL || '';
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || '';
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
export const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || '';
export const i18n_HOST = process.env.REACT_APP_i18n_HOST || '';
export const i18n_API_KEY = process.env.REACT_APP_i18n_API_KEY || '';
